module.exports = __webpack_public_path__ + "img/212f65ddb94ae562d8e90b98ab5941b0.9eda1045.jpg";